<template>
    <transactions-get
        :page="page"
        :include="['transactionable(include:properties,payer,charge(include:payer))']"
    >
        <div
            slot-scope="{
                data: transactions,
                meta,
                error,
                is_loading,
                has_loaded,
                get
            }"
            :class="!has_loaded || error ? '' : 'rounded bg-white shadow'"
        >
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="get"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <template v-else>
                <header class="flex items-center px-4 py-3 sm:px-6 md:py-3 border-b-3 border-grey-bg">
                    <div class="flex-grow">
                        <h1 class="text-lg font-normal">Payments</h1>
                    </div>
                    <div class="w-6 h-6 mr-3">
                        <base-svg
                            v-show="is_loading"
                            name="icon-loading"
                            class="w-full h-full fill-current text-grey"
                        />
                    </div>
                </header>

                <template v-if="meta.count > 0">
                    <transactions-list :transactions="transactions" />

                    <footer class="px-4 text-sm font-semibold rounded-b bg-grey-bg sm:px-6 text-grey-darker">
                        <base-pagination
                            v-model="page"
                            :per-page="meta.per_page"
                            :from="meta.from"
                            :to="meta.to"
                            :last-page="meta.last_page"
                            :count="meta.count"
                            :total="meta.total"
                            :is-disabled="is_loading"
                        />
                    </footer>
                </template>

                <div
                    v-else
                    class="py-16"
                >
                    <div class="max-w-sm px-6 mx-auto text-center">
                        <h2 class="mb-2 text-xl font-semibold">
                            No payments
                        </h2>

                        <div class="text-base text-grey-darker">
                            <p class="mb-6">You haven’t received any payments yet.</p>

                            <p>
                                <router-link
                                    :to="{
                                        name: $router.fix('dashboard.*.overview.index')
                                    }"
                                    class="mx-auto btn btn-with-icon btn-blue"
                                >
                                    <div class="flex items-center w-full h-full">
                                        <base-svg
                                                name="icon-arrow-thin-right-circle"
                                                class="w-6 h-6 mr-2"
                                        />

                                        Go to Dashboard
                                    </div>
                                </router-link>
                            </p>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </transactions-get>
</template>

<script>
    import PaginationMixin from '../../../../../mixins/pagination'
    import TransactionsGet from '../../../../../components/transactions-get'
    import TransactionsList from '../../../../../components/transactions-list'

    export default {
        mixins: [
            PaginationMixin
        ],
        components: {
            TransactionsGet,
            TransactionsList
        }
    }
</script>
